export default __webpack_public_path__ + "static/l2-content-img-1-685b1f2d1a101062127538e17ebb0844.png";